// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__2YZX7","cardIcon":"styles_cardIcon__24F-6","shadowedIcon":"styles_shadowedIcon__1CpW_","cardWithSpan":"styles_cardWithSpan__3pIJM"};